/**
 * Reflects the user's analytics consent into Matomo's cookie consent.
 *
 * Matomo is initialized with `requireCookieConsent`, so it measures cookielessly
 * until consent is granted. Granting pushes `setCookieConsentGiven` (Matomo may
 * store its `_pk_*` cookies); denying/revoking pushes `forgetCookieConsentGiven`
 * (cookies are removed and no new ones are set).
 */
export function setMatomoCookieConsent(granted: boolean): void {
    if (typeof window === 'undefined' || !window._paq) {
        return
    }

    window._paq.push([granted ? 'setCookieConsentGiven' : 'forgetCookieConsentGiven'])
}
